import $ from "jquery";
$(document).ready(function(){

    // If this component exists on these templates then do this && and that the body does not have a class of edit-mode (sitecore added)
    // So by default the component will not do any of this
    if ((document.getElementsByClassName('c-navigation-contents').length) && (!document.querySelector("body").classList.contains("edit-mode"))) {

        let component = '.c-navigation-contents';
        let componentList = $(component).find('ul');
        let header = $('#u-header');
        let isInThreeNine = document.querySelectorAll('div[data-sublayout-title="sl-col--l-3-9-m-3-9-s-12__cell-left"] .c-navigation-contents');
console.log('IsInThreeNine');
        if(isInThreeNine) {
            console.log(isInThreeNine);
            for ( let i=0; i < isInThreeNine.length; i++ ) {
                console.log('Sheeeeeeeaaaat');
                isInThreeNine[i].classList.add('c-navigation-contents--simple');
                console.log(isInThreeNine[i]);
            }
        }

        if($(header).length) {
            // Set up for contents links
            let offsetHeight = 0;
            // Find the height of these items and add them together, update variable
            // you can pass in multiple items to measure, just comma separate them
            // $('#u-nav, #u-nav--context').each(function(){ offsetHeight+=$(this).height() });
            $(header).each(function(){ offsetHeight+=$(this).height() });
            $(componentList).attr('data-magellan', '').attr('data-offset',offsetHeight + 10).attr('data-smooth-scroll','');

            // Set up for an external link coming in with a anchor reference
            // grab target from URL hash (i.e. www.example.com/page-a.html#target-name)
            let externalTarget = window.location.hash;
            // only try to scroll to offset if target has been set in location hash
            if ( externalTarget != '' ){
                let $target = $(externalTarget);
                $('html, body').stop().animate({
                        'scrollTop': $target.offset().top - (offsetHeight + 40)},
                    500,
                    'linear',function () {});
            }
        }

        // when c-navigation-contents is used inside this parent component
        // it needs to behave differently to the 'default'
        if (($('.c-navigation-contents').parents('.c-content-definition-listing').length) || ($('.c-navigation-contents').parents('.c-card-az-listing').length)) {
            // The sticky effect wrapping this component need to be changed
            if ($(window).width() < 960) {
                $('.sticky').attr('data-margin-top','1');
            } else {
                $('.sticky').attr('data-margin-top','10');
            }
        } else if ($('.c-navigation-contents').hasClass('c-navigation-contents--simple')) {
            // This will disable all the default DOM manipulation that hits c-navigation-contents
        } else {
            // We need to start by adding a couple of positional spans to the page
            // These will be used to move the component from one position on Large
            // to another on Medium and Small.
            // Find this components closest parent section
            // And then create a new node to use for positioning
            // Check if there is a sticky effect applied as this adds an extra wrapper
            if ($(component).closest('.cell').find('.sticky').length){
                $(component).addClass('show-for-large').closest('.cell').find('.sticky').prepend('<span class="contentsPositionLarge"></span>');
            }
            else {
                $(component).addClass('show-for-large').closest('.cell').prepend('<span class="contentsPositionLarge"></span>');
            }
            // Second position is always after this component
            if($('.c-content-intro').length) {
                $('<span class="contentsPositionSmall"></span>').insertAfter('.c-content-intro');
            } else {
                $('<span class="contentsPositionSmall"></span>').prependTo('div[data-sublayout-title="sl-col--l-3-6-3-m-0-8-4-s-12__cell-center');
            }
            let componentForSmall = $(component).clone();
            componentForSmall.removeClass('show-for-large').addClass('hide-for-large');
            let whereToMoveTo = $('.contentsPositionSmall');
            componentForSmall.insertAfter(whereToMoveTo);


            // let moveThis = function(position) {
            //     let componentToDetach = $(component);
            //     let whereToMoveTo = $(position);
            //     let block = $(component).detach();
            //     block.insertAfter(whereToMoveTo);
            // };

            // On page load check if we are on a specific viewport
            // If we are move the component
            // if ($(window).width() < 960) {
            //     moveThis('.contentsPositionSmall');
            // } else {
            //     moveThis('.contentsPositionLarge');
            // }

            // On window resize check if we are on a specific viewport
            // If we are move the component
            // $(window).resize(function() {
                // if ($(window).width() < 960) {
                //     moveThis('.contentsPositionSmall');
                // }else {
                //     moveThis('.contentsPositionLarge');
                // }
            // });
        }
    }

});